import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    UndoCheckInInput,
    UndoCheckInMutationResponse,
} from "@/Domains/BookingManagement/Booking/Shared/Mutations/__generated__/UndoCheckInMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: UndoCheckInInput,
    onCompleted: (error: Error | null, result?: boolean | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation UndoCheckInMutation($input: UndoCheckInInput!) {
                UndoCheckInMutation(input: $input)
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as UndoCheckInMutationResponse;
            const success = res.UndoCheckInMutation;

            if (success) {
                onCompleted(null, true);
                return;
            }

            throw new BaseError(
                "UndoCheckInMutation failed with an unexpected Error",
                {
                    context: {
                        bookingId: input.id,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
